
      export const versions = {
        commit: 'c657d5159159e7346649c28a1585d74431d87419',
        branch: 'HEAD'
      };
